import { PROPS, SET_PROPS, PropsAction } from './types'

const initialState: PropsAction = {
  checklist_all: {
    loaded: false,
    employee: undefined,
    checklist: undefined,
  },
}

export const PropsReducer = (state = initialState, action: PROPS) => {
  const { type, payload } = action

  switch (type) {
    case SET_PROPS:
      return { ...state, ...payload }

    default:
      return state
  }
}
